import React, { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import LabelledTextField from '../../../components/LabelledTextField';
import { dateOptions, dateTimeOptions } from '../../../utils/dates';
import { getFireFlowReportLatest } from '../../../services/api';
import FireFlowTestModal from '../../../components/fireFlowTests/FireFlowTestModal';
import PSIGPMChart from '../../../components/fireFlowTests/PSIGPMChart';
import IsAuthorized from '../../../services/authentication/IsAuthorized';
import { makeHydrant, makeFireFlowTest, makeHydrantModel, makeFireFlowTestHydrant, makeFireFlowReport } from '../../../models';
import ExerciseChart from '../../../components/ExerciseChart';
import CircleButton from '../../../components/CircleButton';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import FireFlowFlowHydrantList from '../../../components/fireFlowTests/FireFlowFlowHydrantList';
import { getFireFlowReport } from '../../../services/api/fireFlowReports';
import FireFlowReport from '../../../components/fireFlowTests/FireFlowReport';

const FireFlowTest = () => {
  const [fireFlowReport, setFireFlowReport] = useState(null);
  const [loadingFireFlowReport, setLoadingFireFlowReport] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [startDelete, setStartDelete] = useState(false);
  const { hydrantId, fireFlowTestHydrantId } = useParams();
  const history = useHistory();

  useEffect(() => {
    setupFireFlowReport();
  }, [hydrantId, fireFlowTestHydrantId, history.location]);

  const setupFireFlowReport = async () => {
    try {
      setLoadingFireFlowReport(true);
      let result = undefined;
      if (fireFlowTestHydrantId) {
        result = await getFireFlowReport(fireFlowTestHydrantId);
      } else {
        result = await getFireFlowReportLatest(hydrantId);
      }
      setFireFlowReport(makeFireFlowReport(result));
      setLoadingFireFlowReport(false);
    } catch (ex) {
      setLoadingFireFlowReport(false);
    }
  };

  const toggleModal = () => setModalOpen(!modalOpen);

  const selectTestHydrant = (testHydrantId) => {
    history.push(`/hydrants/${hydrantId}/fireFlowTest/${testHydrantId}`);
  };

  const deleteRecord = async () => {
    try {
      setStartDelete(false);
      // await deleteFireFlowTestHydrant(testHydrant.id);
      history.replace(`/hydrants/${hydrantId}/fireFlowTest`);
    } catch (ex) {
      console.log(ex);
      history.replace(`/hydrants/${hydrantId}/fireFlowTest`);
    }
  };

  const testDate = new Date(fireFlowReport?.testDate ?? null);
  const testDateString = new Intl.DateTimeFormat('en-US', dateTimeOptions).format(testDate);

  const testSuccess = fireFlowReport?.percentDrop >= 0.25;

  const seconds = fireFlowReport?.elapsedSeconds ?? 0;
  const elapsedMinutes = `${Math.floor(seconds / 60)}:${seconds % 60}`
  
  return (
    <div className="hydrant-test force-print-color">
      <div className="report-title">
        <div className="title no-print">
          <h3>Fire Flow Test</h3>
          <div className="form-links no-print">
            <div className='link' onClick={toggleModal}>Choose Test</div>
            {/* <Link to={`/reports/history/${hydrantId}`} target='_blank' className="link">View Test History</Link> */}
          </div>
        </div>
        {loadingFireFlowReport || <CircleButton icon={faPrint} size="large" title="Print" onClick={print} className="no-print" />}
      </div>
      {loadingFireFlowReport && <div className="spinner"></div>}
      {!loadingFireFlowReport && fireFlowReport && (
        <>
          {!startDelete ? (
            <div className="form-actions no-print">
              <IsAuthorized>
                {/* <Link to={`/hydrants/${hydrantId}/fireFlowTest/${testHydrant.id}/edit`} className="link">Edit</Link> */}
                <div className="link" onClick={() => setStartDelete(true)}>Delete</div>
              </IsAuthorized>
            </div>
          ) : (
            <div className="form-actions no-print">
              <span>Are you sure you want to delete this record?</span>
              <button type="button" className="btn btn-primary" onClick={deleteRecord}>Yes</button>
              <button type="button" className="btn btn-secondary" onClick={() => setStartDelete(false)}>No</button>
            </div>
          )}
          <FireFlowReport fireFlowReport={fireFlowReport} loading={loadingFireFlowReport} />
        </>
      )}
      {!loadingFireFlowReport && !fireFlowReport && (
        <div className="empty-body">
          <div className="empty-text">No Test Found</div>
          <div className="empty-text-small">Unable to find a fire flow test.</div>
        </div>
      )}
      <FireFlowTestModal hydrantId={hydrantId} open={modalOpen} toggle={toggleModal} onSelect={selectTestHydrant} />
    </div>
  );
};

export default FireFlowTest;